import { render, staticRenderFns } from "./RegistrarToca.vue?vue&type=template&id=2b9cf078&"
import script from "./RegistrarToca.vue?vue&type=script&lang=js&"
export * from "./RegistrarToca.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarToca.vue?vue&type=style&index=0&id=2b9cf078&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports